(function() {
  document.addEventListener('DOMContentLoaded', () => {
      const Elements = document.querySelectorAll('.-js.my');
      console.log(Elements);
    Elements.forEach(Element => {
      const player = js(Element.id, {
        autoplay: true,
        muted: true,
        loop: true,
        controls: false,
        fluid: false,
        fill: true,
        responsive: true
      });

      player.ready(() => {
        player.loop(true);
        player.play().catch(error => {
          console.log("Autoplay blocked:", error);
        });
      });

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          player.play().catch(error => {
            console.log("Playback failed on visibility change:", error);
          });
        }
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
          if (event.target.contains(Element)) {
            player.play().catch(error => {
              console.log("Playback failed after section load:", error);
            });
          }
        });
      }
    });
  });
})(); 